/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getBooleanDecoder,
  getBooleanEncoder,
  getStructDecoder,
  getStructEncoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type Creator = {
  address: Address;
  verified: boolean;
  /**
   * The percentage share.
   *
   * The value is a percentage, not basis points.
   */
  share: number;
};

export type CreatorArgs = Creator;

export function getCreatorEncoder(): FixedSizeEncoder<CreatorArgs> {
  return getStructEncoder([
    ['address', getAddressEncoder()],
    ['verified', getBooleanEncoder()],
    ['share', getU8Encoder()],
  ]);
}

export function getCreatorDecoder(): FixedSizeDecoder<Creator> {
  return getStructDecoder([
    ['address', getAddressDecoder()],
    ['verified', getBooleanDecoder()],
    ['share', getU8Decoder()],
  ]);
}

export function getCreatorCodec(): FixedSizeCodec<CreatorArgs, Creator> {
  return combineCodec(getCreatorEncoder(), getCreatorDecoder());
}
